/* eslint-disable no-undef */
<template>
    <!-- <div class="big"> -->
    <div class="katexBox" :id="id ? id : randomId" v-html="fomula"></div>
    <!-- <div class="gaizi" :id="`gai${this.id ? this.id : this.randomId}`"></div> -->
    <!-- </div> -->
</template>

<script>
export default {
    props: {
        fomula: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            randomId: `${Math.random().toString(36).substr(2)}${Math.ceil(
                Math.random() * 1000,
            )}${Math.ceil(Math.random() * 780)}${Math.random().toString(36).substr(2)}`,
            gaiziHeight: 0,
        };
    },
    watch: {
        fomula(val) {
            if (val) {
                const bool = val.indexOf('$$') !== -1 || true;
                this.$nextTick(() => {
                    if (bool && document.getElementById(this.id ? this.id : this.randomId)) {
                        // eslint-disable-next-line no-undef
                        renderMathInElement(document.getElementById(this.id ? this.id : this.randomId), {
                            // • auto-render specific keys, e.g.:
                            delimiters: [
                                { left: '$$', right: '$$', display: false },
                                { left: '$', right: '$', display: false },
                                { left: '\\(', right: '\\)', display: false },
                                { left: '\(', right: '\)', display: false },
                                { left: '\\[', right: '\\]', display: false },
                            ],
                            // • rendering keys, e.g.:
                            throwOnError: false,
                        });
                    }
                });
            }
        },
    },
    created() {
        this.$nextTick(() => {
            // eslint-disable-next-line no-undef
            renderMathInElement(document.getElementById(this.id ? this.id : this.randomId), {
                // • auto-render specific keys, e.g.:
                delimiters: [
                    { left: '$$', right: '$$', display: false },
                    { left: '$', right: '$', display: false },
                    { left: '\\(', right: '\\)', display: false },
                    { left: '\(', right: '\)', display: false },
                    { left: '\\[', right: '\\]', display: false },
                ],
                // • rendering keys, e.g.:
                throwOnError: false,
            });
            // 设置元素高度为200px
            // document.getElementById(`gai${this.id ? this.id : this.randomId}`).style.height =
            //   document.getElementById(this.id ? this.id : this.randomId)?.clientHeight;
            // this.gaiziHeight =
            //   document.getElementById(this.id ? this.id : this.randomId)?.clientHeight || 0;
        });
    },
    methods: {
        // 以后可能会用到，先不删除
        handleSpecialSymbols(val) {
            return val.replaceAll('&nbsp;', ' ');
        },
    },
};
</script>

<style lang="scss">
// .big {
// position: relative;
// z-index: 0;
.katexBox {
    // overflow: auto;
    // position: relative;
    overflow-x: auto;
    overflow-y: hidden;
    font-size: 28px;
    line-height: 48px;

    p {
        // font-size: 28px;
        word-break: break-word;
    }

    .latex {
        table {
            border-collapse: collapse;
            border-spacing: 0;
            border: 1px solid #07a9fe;
            border-width: 0.5px;

            td {
                background-color: #fff;
                border: 1px solid #c5c5c5;
                border-width: 0.5px;
                overflow: visible;
                cursor: text;
            }
        }
    }
}

.gaizi {
    position: absolute;
    height: 100%;
    width: 100%;
    // float: left;
    top: 0;
    left: 0;
    z-index: 2;
}

// }

// .katexBox::before {
//   position: absolute;
//   content: '';
//   top: 0;
//   left: 0;
//   height: 100%;
//   width: 100%;
//   // background: red;
// }</style>
